// React import not needed with new JSX transform
import { MessageSquare, Sparkles, FileText, Calculator, Image, Search, BookOpen } from 'lucide-react'

export function EmptyState() {
  const features = [
    {
      icon: Sparkles,
      title: "Ask a question",
      description: "Get instant answers from our AI assistant"
    },
    {
      icon: FileText,
      title: "Analyze documents",
      description: "Upload files for analysis and insights"
    },
    {
      icon: Calculator,
      title: "Solve problems",
      description: "Get help with calculations and technical issues"
    },
    {
      icon: Image,
      title: "Generate image",
      description: "Create visual content and illustrations"
    },
    {
      icon: Search,
      title: "Search information",
      description: "Find answers from internal knowledge base"
    },
    {
      icon: BookOpen,
      title: "Learning product",
      description: "Explore educational resources and product knowledge"
    }
  ]

  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
      {/* Logo and Title */}
      <div className="mb-8">
        <div className="mb-4 flex justify-center">
          <img 
            src="/giatec-logo.png" 
            alt="Giatec" 
            className="h-16 w-auto object-contain opacity-80 max-w-xs"
            onError={(e) => {
              e.currentTarget.style.display = 'none'
            }}
          />
        </div>
        <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-2">
          Welcome to Giatec Chat 
        </h1>
        <div className="mb-2">
          <p className="text-xl font-semibold bg-gradient-to-r from-emerald-600 to-green-600 bg-clip-text text-transparent">
            Intelligence at Your Fingertips
          </p>
        </div>
      </div>

      {/* Features List - Non-interactive display */}
      <div className="max-w-3xl w-full mb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-start gap-3 p-4 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800/50"
            >
              <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500 to-green-600 text-white flex items-center justify-center">
                <feature.icon className="w-4 h-4" />
              </div>
              <div className="flex-1 text-left min-w-0">
                <h3 className="font-medium text-sm text-gray-800 dark:text-gray-100 mb-0.5">
                  {feature.title}
                </h3>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Start Hint */}
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <MessageSquare className="w-4 h-4" />
        <span>Start typing below to begin a conversation</span>
      </div>
    </div>
  )
}

